export default __webpack_public_path__ + "static/media/CORPe.2de1f0a0.png";